import React from 'react';

import { PrivateCopyExistenceRecord } from 'types';
import { PageKey, SortOrder } from 'enums';

import { LentTable } from '../lent-table';
import { fetchTableItems } from '../lent-api';
import { lentHistoryDigitalColumns } from '../lent-columns';

const fetchFunction = fetchTableItems<PrivateCopyExistenceRecord>(
  '/api/private-copy-existence-record/aggregate/my-copies'
);

export function LentHistoryTableDigital() {
  return (
    <LentTable<PrivateCopyExistenceRecord>
      title="Vrácené digitální archiválie"
      pageKey={PageKey.PORTFOLIO_LENT_HISTORY_DIGITAL}
      columns={lentHistoryDigitalColumns}
      fetchFunction={fetchFunction}
      params={{
        sort: [
          { field: 'archivalUnitReference.numericId', order: SortOrder.ASC },
        ],
      }}
    />
  );
}
